import { ROUTES } from 'module/navigation/enums/routes.enums';
import { getPermissionAwareDetailLocation } from 'core/utils/permissionAwareNavigation';

export type LogbookNoteDetailOptions = {
	canEdit: boolean;
	/** Shift/employee notes can only be edited within a week. */
	isEditableWindow?: boolean;
};

export const getShiftNoteDetailLocation = (
	noteId: number | string,
	options: LogbookNoteDetailOptions,
): { pathname: string } => {
	const canEdit = options.canEdit && (options.isEditableWindow ?? true);
	return getPermissionAwareDetailLocation({
		id: noteId,
		canEdit,
		editPath: ROUTES.EDIT_SHIFT_NOTES,
		viewPath: ROUTES.VIEW_SHIFT_NOTES,
		paramName: ':noteId',
	});
};

export const getEmployeeNoteDetailLocation = (
	noteId: number | string,
	options: LogbookNoteDetailOptions,
): { pathname: string } => {
	const canEdit = options.canEdit && (options.isEditableWindow ?? true);
	return getPermissionAwareDetailLocation({
		id: noteId,
		canEdit,
		editPath: ROUTES.EDIT_EMPLOYEE_NOTES,
		viewPath: ROUTES.VIEW_EMPLOYEE_NOTES,
		paramName: ':noteId',
	});
};
